import { put } from 'redux-saga/effects';
import {reset} from 'redux-form';

import { createRequest, uploadFile } from 'misc/zendesk';
import * as types from 'misc/types';
import { popup_icon_type } from 'components/shared/popup/Popup';
import { getText } from 'misc/helpers';

// Get info about browser
navigator.browserSpecs = (function(){
    var ua= navigator.userAgent, tem, 
    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if(/trident/i.test(M[1])){
        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name:'IE',version:(tem[1] || '')};
    }
    if(M[1]=== 'Chrome'){
        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
        if(tem!= null) return {name:tem[1].replace('OPR', 'Opera'),version:tem[2]};
    }
    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
    return {name:M[0],version:M[1]};
})();


export function* postSupport(action) {

    console.log("posting...");

    // Check if message is set
    if(action.payload.message && action.payload.message !== ""){
        // Add browser info to initial support message
        let message = action.payload.message+"\n\n";
            
        message += "--------------------\n";
        message += "KundID: "+action.payload.customerId+"\n";
        message += "--------------------\n";
        message += "Info:\n";
        message += "Webbapp\n";
        message += "Webbläsare: "+navigator.browserSpecs.name+"\n";
        message += "Webbläsare version: "+navigator.browserSpecs.version;

        // Build support request
        const request = {
            requester: {
                name: action.payload.name,
                email: action.payload.email
            }, 
            subject: message.trunc(20),
            comment: {
                body: message
            }
        };

        // Add attachment to request
        if(action.payload.screenshot){
            console.log("uploading attachment...");
        
            let fileToUpload = action.payload.screenshot[0];
            
            // Upload file to zendesk
            let upload_response = yield uploadFile(fileToUpload);
            
            request.comment.uploads = [upload_response.data.upload.token];
        }

        // Send request to zendesk
        yield createRequest(request);

        yield put({ type: types.SAGA_SUPPORT_POST.SUCCESS });
        
        yield put(reset('SupportForm'));
        
        // Show success popup
        yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.success,
                text: getText('Missing','Ditt meddelande har skickats!')
            }
        });
    }else{
         // Show error popup
         yield put({
            type: types.POPUP_SHOW,
            payload: {
                show: true,
                icon: popup_icon_type.error,
                text: getText('Missing','Ditt meddelande är tomt.')
            }
        });
        
    }
}


// WEBPACK FOOTER //
// ./src/sagas/support.js